import UserCustomSignatureParams from "@/domain/entities/user/UserCustomSignature";

const normalizeWebsiteUrl = (website: string | undefined): string => {
    if (!website || !website.trim()) {
        return "";
    }

    const trimmedWebsite = website.trim();
    if (
        !trimmedWebsite.startsWith("http://") &&
        !trimmedWebsite.startsWith("https://")
    ) {
        return `https://${trimmedWebsite}`;
    }

    return trimmedWebsite;
};

const getSignatureTemplate = (signatureParams: UserCustomSignatureParams) => {
    const normalizedWebsite = normalizeWebsiteUrl(signatureParams.website);
    const websiteHref = normalizedWebsite;
    const websiteText = signatureParams.website || "";

    const template = `
    <table id="mailvista-signature" cellpadding="0" cellspacing="0" border="0" style="font-family: 'Source Sans 3', Arial, sans-serif; font-size: 14px; line-height: 1.4; color: #333333; border-collapse: collapse;">
            <tr>
                ${
                    signatureParams.avatarURL
                        ? `<td style="padding-right: 15px; vertical-align: middle; width: 100px;">
                    <img src="{{avatar}}" alt="{{name}}" width="80" height="80" style="width: 80px; height: 80px; border-radius: 50%; object-fit: cover; display: block;" />
                  </td>`
                        : ""
                }
                <td style="vertical-align: top; border-left: 2px solid #8562c7; padding-left: 15px;">
                  <p style="margin: 0; padding-bottom: 5px; font-size: 16px; color: #8562c7;">
                    <strong style="font-size: 16px; color: #8562c7;">{{name}}</strong>
                  </p>
                  <p style="margin: 0; font-size: 13px; color: #666666;">
                    {{jobTitle}} ${signatureParams.jobTitle && signatureParams.companyName ? "-" : ""} {{company}}
                  </p>
                  <p style="margin: 0; font-size: 13px;">
                    <a href="mailto:{{email}}" style="color: #8562c7; text-decoration: none;">{{email}}</a>
                  </p>
                  <p style="margin: 0; padding-bottom: 5px; font-size: 13px; color: #666666;">
                    {{phone}}
                  </p>
                  <p style="margin: 0; font-size: 13px;">
                    <a href="{{websiteHref}}" style="color: #8562c7; text-decoration: none;">{{websiteText}}</a>
                  </p>
                  <p style="margin: 0; padding-top: 8px; font-size: 12px; color: #888888;">
                    {{other}}
                  </p>
                </td>
            </tr>
        </table>`;

    return template
        .replace(/{{avatar}}/g, signatureParams.avatarURL || "")
        .replace(/{{name}}/g, signatureParams.name || "")
        .replace(/{{email}}/g, signatureParams.email || "")
        .replace(/{{phone}}/g, signatureParams.phone || "")
        .replace(/{{jobTitle}}/g, signatureParams.jobTitle || "")
        .replace(/{{company}}/g, signatureParams.companyName || "")
        .replace(/{{websiteHref}}/g, websiteHref)
        .replace(/{{websiteText}}/g, websiteText)
        .replace(/{{other}}/g, signatureParams.other || "");
};

export default getSignatureTemplate;
